import SVGProps from 'src/components/icons/config/svg-props' //
// Auto-generated file created by svgr-cli source svg-template.cjs
// Run npm run generate-icons to update
// Do not edit
const SvgVesselFrontIcon = (props: SVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={props.size || '1em'}
    height={props.size || '1em'}
    fill="none"
    viewBox="0 0 64 64"
    role="img"
    className="icon"
    {...props}
  >
    <path
      fill="currentColor"
      d="M25.602 9.6a3.2 3.2 0 0 1 3.2-3.2h6.4a3.2 3.2 0 0 1 3.2 3.2v9.6h6.4a3.2 3.2 0 0 1 3.2 3.2v12.508l5.054 1.443a3.2 3.2 0 0 1 2.034 4.402l-5.953 13.095a6.4 6.4 0 0 1-5.826 3.752H20.692a6.4 6.4 0 0 1-5.826-3.752L8.913 40.753a3.2 3.2 0 0 1 2.034-4.402l5.055-1.444V22.4a3.2 3.2 0 0 1 3.2-3.2h6.4zm3.2 9.6h6.4V9.6h-6.4zm-9.6 14.793 11.92-3.406a3.2 3.2 0 0 1 1.759 0l11.92 3.406V22.4h-25.6zm12.8-.329-20.176 5.764 5.953 13.096a3.2 3.2 0 0 0 2.913 1.876h22.619a3.2 3.2 0 0 0 2.913-1.876l5.953-13.096z"
    />
  </svg>
)
export default SvgVesselFrontIcon
